import api from '@/store/api'

const state = {
  renderBatches: [],
  renderStats: {},
  renderCapacity: {}
}

const actions = {
  getRenderBatches: ({state, commit}) => {
    return api.getRenderBatches().then((renderBatches) => {
      commit('setRenderBatches', renderBatches.data)
      commit('setRenderCapacity', renderBatches.capacity)
      return commit('setRenderStats', renderBatches.stats)
    })
  },
  updateRenderQueue: ({ state, commit }, data) => {
    return api.updateRenderQueue(data).then(() => {
    })
  },
  updateRenderQueueBatchWise: ({ state, commit }, data) => {
    return api.updateRenderQueueBatchWise(data).then((renderBatches) => {
      commit('setRenderBatches', renderBatches.data)
      commit('setRenderCapacity', renderBatches.capacity)
      return commit('setRenderStats', renderBatches.stats)
    })
  },
  deleteRenderBatch: ({ state, commit }, data) => {
    return api.deleteRenderBatch(data).then(() => {
    })
  },
  deleteRenderQueue: ({ state, commit }, data) => {
    return api.deleteRenderQueue(data).then(() => {
    })
  },
  deleteRenderBot: ({ state, commit }, data) => {
    return api.deleteRenderBot(data).then(() => {
    })
  }
}

const mutations = {
  setRenderBatches (state, renderBatches) {
    state.renderBatches = renderBatches
  },
  setRenderStats (state, renderStats) {
    state.renderStats = renderStats
  },
  setRenderCapacity (state, renderCapacity) {
    if (!renderCapacity) {
      state.renderCapacity = {
        html: 0,
        psd: 0,
        html_video: 0,
        after_effects: 0
      }
    } else {
      state.renderCapacity = renderCapacity
    }
  }
}

const getters = {
  renderBatches: state => {
    return state.renderBatches
  },
  renderStats: state => {
    return state.renderStats
  },
  renderCapacity: state => {
    return state.renderCapacity
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/render.js